<template>
  <div>
            <h1>Logout....</h1>
  </div>
</template>

<script>
export default {
  data: () => ({
    username: "",
    password: "",
  }),
  mounted() {
    this.logout();
  },
  methods: {
    logout: function () {
      // localStorage.setItem("user_token", "ini user token");
      localStorage.removeItem('msCurrentRole')
      localStorage.removeItem('msApprovalFilter')


      this.$store.dispatch("auth/logout").then(() => {
          window.location.replace("https://sso.bps.go.id/auth/realms/pegawai-bps/protocol/openid-connect/logout"+"?&redirect_uri=" +
                window.location.protocol +
            "//" +
            window.location.host +
            process.env.VUE_APP_PUBLIC_PATH +
            "/login");
        this.$router.push("/");       
      });
    },
  },
};
</script>
